
import React, { useEffect, useReducer, useRef, useState } from 'react'
import styled from 'styled-components'
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import QRCode from 'react-qr-code';
import PrimaryButton from '../GenericComponents/PrimaryButton';

const QcModal = ({ handleShareBtn, setIsQcModalOpen, qcLink }) => {

    const handleCloseModal = () => {
        qcLink = null;
        setIsQcModalOpen(false)

    }
    const { t } = useTranslate();
    return (
        <FullScreenItem>
            <RatingCard>
                <Line>
                    <ModalTitle>
                        <h1>{t('new_chat.new_quick_chat')} </h1>
                    </ModalTitle>
                    <CloseBtn onClick={() => handleCloseModal()}>
                        <CloseIcon />
                    </CloseBtn>
                </Line>

                <Group>
                    <SubtitleWrapper>
                        <p>{t('quick_chat.cautionModal')}</p>
                    </SubtitleWrapper>
                </Group>

                <TitleWrapper style={{ marginBottom: "10px" }}>
                    <h1>{t('chat_details.scan_easy_access').toUpperCase()}</h1>
                </TitleWrapper>
                <QrCodeWrapper>
                    <QRCode
                        style={{ height: "auto", width: "100px", background: "white", padding: "3px" }}
                        value={qcLink}
                    />
                </QrCodeWrapper>

                <TitleWrapper style={{ marginBottom: "10px" }}>
                    <h1>{t('chat_details.generated_link').toUpperCase()} </h1>
                </TitleWrapper>

                <Group>
                    <InputCopyWrapper>
                        <CustomInput
                            readOnly
                            value={qcLink}
                        />
                    </InputCopyWrapper>
                    <PrimaryButton onClick={() => handleShareBtn(qcLink)} style={{ padding: "16px" }}>
                        {t('quick_chat.copy_link')}
                    </PrimaryButton>
                </Group>
            </RatingCard>
        </FullScreenItem >

    )
}

export default QcModal

const FullScreenItem = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:fixed;
width:100%;
height:100%;
background:rgba(0,0,0,0.3);
left:0;
top:0;
z-index:5;
`
const RatingCard = styled.div`
display:flex;
flex-direction:column;
min-height:200px;
max-width:400px;
width:100%;
background:${({ theme }) => theme.menu.background};
border-radius:4px;
padding:30px;
align-items:center;
position:relative;


`
const TitleWrapper = styled.div`
display:flex;
width:100%;

  h1 {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
    text-transform: uppercase;
  }
`
const CustomInput = styled.input`
display:flex;
padding:13px 16px;
background:none;
outline:none;
color:white;
font-size: 16px;
font-weight: 400;
line-height: 22px;
text-align: left;
border:none;
border-right:1px solid ${({ theme }) => theme.sidebar.borderColor};
width:100%;
   color:${({ theme }) => theme.menu.primaryTextColor};
`
const Line = styled.div`
display:flex;
align-items:center;
width:100%;
`
const CloseBtn = styled.button`
position:absolute;
display:flex;
align-items:center;
background:none;
border:none;
cursor:pointer;
right:30px;
  svg{
height:28px;
width:28px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`
const Group = styled.div`
display:flex;
flex-direction:column;
gap:25px;
width:100%;
`
const InputCopyWrapper = styled(Line)`
border:1px solid ${({ theme }) => theme.menu.secondaryTextColor};
border-radius:4px;
overflow:hidden;
color:${({ theme }) => theme.menu.primaryTextColor};
width:100%;
`

const SubtitleWrapper = styled.div`
display: flex;
justify-content: space-between;
margin:20px 0;
p {
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

}
`

const ModalTitle = styled.div`
display: flex;
margin-left:auto;
margin-right:auto;
    h1{
        font-size:20px;
        line-height:24px;
        font-weight:600;
        color:${({ theme }) => theme.menu.primaryTextColor};
    }

`
const QrCodeWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
margin-bottom:20px;
`